<div class="body" @show>

    <div class="table-wrapper">

        <div class="row">

            <div class="header-cell"></div>

            <ng-container *ngFor="let column of columns">

                <div class="header-cell">{{column.display}}</div>

            </ng-container>

        </div>

        <ng-container *ngFor="let row of rows">

            <div class="row">
    
                <div class="row-header-cell">{{row.display}}</div>

                <ng-container *ngFor="let entry of row.values|keyvalue; let i = index">

                    <mat-icon class="body-cell" [class.disabled]="!editMode" [ngClass]="entry.value? 'selected': 'unselected'" (click)="cellClicked(row.componentId, entry.key)">{{entry.value? 'done': 'clear'}}</mat-icon>

                </ng-container>
    
            </div>
    
        </ng-container>

    </div>

</div>
